import { render, staticRenderFns } from "./SlugSummaryCard.vue?vue&type=template&id=6d5969a2&scoped=true&"
import script from "./SlugSummaryCard.vue?vue&type=script&lang=ts&"
export * from "./SlugSummaryCard.vue?vue&type=script&lang=ts&"
import style0 from "./SlugSummaryCard.vue?vue&type=style&index=0&id=6d5969a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5969a2",
  null
  
)

export default component.exports